<script setup>
const props = defineProps(['activeColor','text'])
</script>

<template>
  <div class="d-flex ga-2 justify-center align-center">
    <div :class="`circle-size rounded-circle ${activeColor ? 'bg-primary' : 'bg-grey-darken-1'}`"></div>
    <div>{{props.text}}</div>
  </div>
</template>

<style scoped>
.circle-size {
  min-width: 0.7em;
  min-height: 0.7em;
}
</style>